import { render } from "./WizardPanel.vue?vue&type=template&id=75ad4861"
import script from "./WizardPanel.vue?vue&type=script&lang=js"
export * from "./WizardPanel.vue?vue&type=script&lang=js"
script.render = render

export default script